import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["display"];

  connect() {
    this.recalculate();
  }

  recalculate() {
    const totalValueInputs = this.element.querySelectorAll(
      "[data-order-product-target='totalValue']",
    );

    let sum = 0;
    totalValueInputs.forEach((input) => {
      const wrapper = input.closest(".nested-form-wrapper");
      if (wrapper && wrapper.dataset.newRecord === "destroyed") return;

      const destroyInput = wrapper?.querySelector("input[name*='_destroy']");
      if (destroyInput && destroyInput.value === "1") return;

      const value = parseFloat(String(input.value).replace(",", ".")) || 0;
      sum += value;
    });

    if (this.hasDisplayTarget) {
      this.displayTarget.textContent = sum.toLocaleString("pt-BR", {
        style: "currency",
        currency: "BRL",
      });
    }
  }
}
